// src/components/Landing/ContactPage.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ContactPage.css';

const ContactPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleWhatsAppClick = (message = '') => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/554137984531?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className="contact-page">
      {/* Header Navigation */}
      <nav className="contact-nav">
        <div className="contact-nav-content">
          <Link to="/" className="contact-logo">
            <img src="/logolandingpage.png" alt="DRE Pro Logo" />
          </Link>
          <Link to="/" className="contact-back-btn">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            <span>Voltar ao Site</span>
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1>Entre em Contato</h1>
          <p>Estamos aqui para ajudar você a transformar sua gestão financeira</p>
          <div className="contact-hero-stats">
            <div className="contact-stat">
              <span className="contact-stat-number">24h</span>
              <span className="contact-stat-label">Tempo Médio de Resposta</span>
            </div>
            <div className="contact-stat">
              <span className="contact-stat-number">5 dias</span>
              <span className="contact-stat-label">Por Semana Disponível</span>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="contact-content">
        <div className="contact-container">
          {/* Sidebar com informações rápidas */}
          <aside className="contact-sidebar">
            <div className="contact-quick-info">
              <h3>Contato Rápido</h3>
              <div className="quick-contact-item">
                <div className="quick-icon">📱</div>
                <div>
                  <strong>WhatsApp</strong>
                  <p>+55 41 3798-4531</p>
                </div>
              </div>
              <div className="quick-contact-item">
                <div className="quick-icon">📧</div>
                <div>
                  <strong>Email</strong>
                  <p>contato@drepro.com.br</p>
                </div>
              </div>
              <div className="quick-contact-item">
                <div className="quick-icon">🕒</div>
                <div>
                  <strong>Horário</strong>
                  <p>Seg. a Sex., 8h às 18h</p>
                </div>
              </div>
              <div className="quick-contact-item">
                <div className="quick-icon">🌍</div>
                <div>
                  <strong>Localização</strong>
                  <p>Curitiba, Paraná, Brasil</p>
                </div>
              </div>
            </div>


          </aside>

          {/* Main contact content */}
          <article className="contact-article">
            {/* Canais de Atendimento */}
            <section className="contact-section">
              <h2>Canais de Atendimento</h2>
              <p>Escolha o canal mais conveniente para entrar em contato conosco</p>
              
              <div className="contact-channels">
                <div className="contact-channel whatsapp">
                  <div className="channel-icon">📱</div>
                  <div className="channel-content">
                    <h3>WhatsApp - Principal</h3>
                    <p>Canal preferencial para suporte técnico, dúvidas comerciais e configuração inicial</p>
                    <div className="channel-details">
                      <div className="channel-item">
                        <strong>Número:</strong> +55 41 3798-4531
                      </div>
                      <div className="channel-item">
                        <strong>Horário:</strong> Segunda a Sexta, 8h às 18h
                      </div>
                      <div className="channel-item">
                        <strong>Tempo resposta:</strong> Até 2 horas
                      </div>
                    </div>
                    <div className="channel-actions">
                      <button 
                        onClick={() => handleWhatsAppClick('Olá! Gostaria de conhecer melhor o DRE Pro')}
                        className="channel-btn primary"
                      >
                        Iniciar Conversa
                      </button>
                    </div>
                  </div>
                </div>

                <div className="contact-channel email">
                  <div className="channel-icon">📧</div>
                  <div className="channel-content">
                    <h3>Email Comercial</h3>
                    <p>Para informações comerciais, parcerias e propostas empresariais</p>
                    <div className="channel-details">
                      <div className="channel-item">
                        <strong>Email:</strong> contato@drepro.com.br
                      </div>
                      <div className="channel-item">
                        <strong>Tempo resposta:</strong> Até 24 horas
                      </div>
                    </div>
                    <div className="channel-actions">
                      <a 
                        href="mailto:contato@drepro.com.br?subject=Interesse no DRE Pro"
                        className="channel-btn secondary"
                      >
                        Enviar Email
                      </a>
                    </div>
                  </div>
                </div>

                <div className="contact-channel support">
                  <div className="channel-icon">🛠️</div>
                  <div className="channel-content">
                    <h3>Suporte Técnico</h3>
                    <p>Para questões técnicas, bugs, problemas de acesso e configuração</p>
                    <div className="channel-details">
                      <div className="channel-item">
                        <strong>Email:</strong> suporte@drepro.com.br
                      </div>
                      <div className="channel-item">
                        <strong>WhatsApp:</strong> +55 41 3798-4531
                      </div>
                      <div className="channel-item">
                        <strong>Tempo resposta:</strong> Até 4 horas
                      </div>
                    </div>
                    <div className="channel-actions">
                      <button 
                        onClick={() => handleWhatsAppClick('Preciso de suporte técnico com o DRE Pro')}
                        className="channel-btn primary"
                      >
                        Solicitar Suporte
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Tipos de Atendimento */}
            <section className="contact-section">
              <h2>Como Podemos Ajudar</h2>
              <div className="help-types">
                <div className="help-type">
                  <div className="help-icon">🚀</div>
                  <h3>Primeiros Passos</h3>
                  <p>Configuração inicial, importação de dados, tour pela plataforma</p>
                  <button 
                    onClick={() => handleWhatsAppClick('Olá! Sou novo no DRE Pro e gostaria de ajuda para começar')}
                    className="help-btn"
                  >
                    Começar Agora
                  </button>
                </div>

                <div className="help-type">
                  <div className="help-icon">🎓</div>
                  <h3>Treinamento</h3>
                  <p>Sessões personalizadas para aproveitar ao máximo o sistema</p>
                  <button 
                    onClick={() => handleWhatsAppClick('Gostaria de agendar um treinamento personalizado do DRE Pro')}
                    className="help-btn"
                  >
                    Agendar Treinamento
                  </button>
                </div>

                <div className="help-type">
                  <div className="help-icon">💼</div>
                  <h3>Consultoria</h3>
                  <p>Análise financeira especializada e otimização de processos</p>
                  <button 
                    onClick={() => handleWhatsAppClick('Interesse em consultoria financeira especializada')}
                    className="help-btn"
                  >
                    Solicitar Consultoria
                  </button>
                </div>

                <div className="help-type">
                  <div className="help-icon">🔧</div>
                  <h3>Problemas Técnicos</h3>
                  <p>Resolução de bugs, problemas de acesso, erros de importação</p>
                  <button 
                    onClick={() => handleWhatsAppClick('Estou enfrentando um problema técnico no DRE Pro')}
                    className="help-btn"
                  >
                    Reportar Problema
                  </button>
                </div>

                <div className="help-type">
                  <div className="help-icon">💰</div>
                  <h3>Dúvidas Comerciais</h3>
                  <p>Planos, preços, upgrades, cancelamentos e faturamento</p>
                  <button 
                    onClick={() => handleWhatsAppClick('Tenho dúvidas sobre planos e preços do DRE Pro')}
                    className="help-btn"
                  >
                    Falar sobre Planos
                  </button>
                </div>

                <div className="help-type">
                  <div className="help-icon">🤝</div>
                  <h3>Parcerias</h3>
                  <p>Oportunidades de parceria, integração, revenda</p>
                  <button 
                    onClick={() => handleWhatsAppClick('Interesse em oportunidades de parceria com o DRE Pro')}
                    className="help-btn"
                  >
                    Propor Parceria
                  </button>
                </div>
              </div>
            </section>

            {/* SLA e Compromissos */}
            <section className="contact-section">
              <h2>Nossos Compromissos de Atendimento</h2>
              <div className="sla-grid">
                <div className="sla-card">
                  <div className="sla-icon">⚡</div>
                  <h3>Resposta Rápida</h3>
                  <div className="sla-details">
                    <div className="sla-item">
                      <span className="sla-time">2 horas</span>
                      <span className="sla-desc">WhatsApp (horário comercial)</span>
                    </div>
                    <div className="sla-item">
                      <span className="sla-time">24 horas</span>
                      <span className="sla-desc">Email comercial</span>
                    </div>
                    <div className="sla-item">
                      <span className="sla-time">4 horas</span>
                      <span className="sla-desc">Suporte técnico</span>
                    </div>
                  </div>
                </div>

                <div className="sla-card">
                  <div className="sla-icon">🎯</div>
                  <h3>Resolução Eficiente</h3>
                  <div className="sla-details">
                    <div className="sla-item">
                      <span className="sla-time">95%</span>
                      <span className="sla-desc">Problemas resolvidos no primeiro contato</span>
                    </div>
                    <div className="sla-item">
                      <span className="sla-time">24h</span>
                      <span className="sla-desc">Tempo máximo para resolução</span>
                    </div>
                  </div>
                </div>

                <div className="sla-card">
                  <div className="sla-icon">🏆</div>
                  <h3>Qualidade Garantida</h3>
                  <div className="sla-details">
                    <div className="sla-item">
                      <span className="sla-time">100%</span>
                      <span className="sla-desc">Equipe especializada em gestão financeira</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* FAQ de Contato */}
            <section className="contact-section">
              <h2>Perguntas Frequentes sobre Atendimento</h2>
              <div className="contact-faq">
                <div className="faq-item">
                  <h3>Qual o melhor canal para dúvidas urgentes?</h3>
                  <p>O WhatsApp é nosso canal principal para atendimento rápido. Para emergências críticas, use a opção "Suporte Urgente" na mensagem.</p>
                </div>

                <div className="faq-item">
                  <h3>Vocês atendem finais de semana?</h3>
                  <p>Nosso atendimento padrão é de segunda a sexta, das 8h às 18h. Para emergências críticas, monitoramos mensagens prioritárias.</p>
                </div>

                <div className="faq-item">
                  <h3>Como agendar uma demonstração?</h3>
                  <p>Entre em contato via WhatsApp ou use o botão "Agendar Demo" na página principal. Demonstrações são gratuitas e personalizadas.</p>
                </div>

                <div className="faq-item">
                  <h3>Oferecem treinamento personalizado?</h3>
                  <p>Sim! Especialmente para clientes Business Pro. Oferecemos sessões de treinamento adaptadas às necessidades da sua empresa.</p>
                </div>

                <div className="faq-item">
                  <h3>Como reportar bugs ou problemas?</h3>
                  <p>Use o canal de Suporte Técnico via WhatsApp ou email. Forneça detalhes como navegador, mensagens de erro e passos para reproduzir.</p>
                </div>
              </div>
            </section>

            {/* Equipe */}
            <section className="contact-section">
              <h2>Nossa Equipe</h2>
              <div className="team-intro">
                <p>
                  Nossa equipe multidisciplinar combina expertise em tecnologia, contabilidade e 
                  atendimento ao cliente para oferecer o melhor suporte possível.
                </p>
              </div>
              
              <div className="team-areas">
                <div className="team-area">
                  <div className="area-icon">💻</div>
                  <h3>Desenvolvimento</h3>
                  <p>Engenheiros especializados em fintech prontos para resolver questões técnicas complexas</p>
                </div>

                <div className="team-area">
                  <div className="area-icon">📊</div>
                  <h3>Contabilidade</h3>
                  <p>Contadores e especialistas em finanças para consultoria e análises avançadas</p>
                </div>

                <div className="team-area">
                  <div className="area-icon">🎯</div>
                  <h3>Customer Success</h3>
                  <p>Especialistas em sucesso do cliente focados em maximizar seus resultados</p>
                </div>
              </div>
            </section>

            <div className="contact-footer-text">
              <p>
                <strong>
                  Estamos aqui para garantir que você tenha a melhor experiência possível 
                  com o DRE Pro. Não hesite em entrar em contato!
                </strong>
              </p>
              <p>
                Responderemos sua mensagem o mais rápido possível e com toda a atenção 
                que você e seu negócio merecem.
              </p>
            </div>
          </article>
        </div>
      </main>

      {/* Footer */}
      <footer className="contact-footer">
        <div className="contact-footer-content">
          <Link to="/" className="contact-footer-logo">
            <img src="/logolandingpage.png" alt="DRE Pro Logo" />
          </Link>
          <p>&copy; {new Date().getFullYear()} DRE Pro. Transformando gestão financeira desde 2024.</p>
          <Link to="/" className="contact-footer-back">
            Voltar ao Site Principal
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;